exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.data-help {\n  display: block;\n  white-space: pre-wrap;\n  margin-top: 5px;\n  font-size: 12px;\n  margin-left: 20px;\n}\n", ""]);

// exports
